import IPrimaryPersonalDocument from "@/module/main/dto/customer/IPrimaryPersonalDocument";
import PrimaryDocumentType from "@/module/main/dto/customer/PrimaryDocumentTypeEnum";
import IIdentificationDocument from "@/module/main/dto/customer/IIdentificationDocument";

export default class PrimaryPersonalDocument implements IPrimaryPersonalDocument {
    constructor(
        public type?: PrimaryDocumentType,
        public identityCard?: IIdentificationDocument,
        public residencePermit?: IIdentificationDocument,
    ) {
    }
}
